import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Draggable from 'react-draggable';
import styled from 'styled-components';
import { Paper, Typography, Tabs, Tab } from '@material-ui/core'
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import { RootState } from '../redux/rootReducer';
import { FolderDb, setCurrentFolder } from '../redux/folderDbSlice';
import { RelationUserFolderDb, updateRelationUserFolder } from '../redux/relationUserFolderDbSlice';
import { updateUserCondition } from '../redux/userConditionSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useCurrentFolderId from '../hooks/useCurrentFolderId';
import useUserCondition from '../hooks/useUserCondition';
import useWindowSize from '@rehooks/window-size';

import { getTimestamp } from '../general';
import DraggableSort from '../general/DraggableSort';
import TabPanel, { TabsAppBar, a11yProps } from './TabPanel';
import AddFolderDialog from './AddFolderDialog';
import LeaveFolderDialog from './LeaveFolderDialog';

const FolderListPaper = styled(Paper)`
  position: relative;
  height: 100vh;
`
const HedderPaper = styled(Paper)`
  position: sticky;
  left: 0px;
  top: 0px;
  height: 24px;
  width: 100%;
  background-color: white;
  z-index: 1;
`
type CustomListItemProps = {
  selected?: boolean;
  dragging?: boolean;
}
const CustomListItem = styled.div<CustomListItemProps>`
  position: absolute;
  display: flex;
  overflow: hidden;
  align-items: center;
  box-sizing: border-box;
  width: inherit;
  height: 48px;
  padding: 8px 16px;
  cursor: pointer;
  pointer-events: ${props => props.dragging ? 'none' : undefined};
  z-index: ${props => props.dragging ? 2 : 1};
  background-color: ${props => props.selected ? 'rgba(0, 0, 0, 0.08) !important' : undefined};
  transition: ${props => {
    const clickTransition = 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
    if (props.dragging) return clickTransition;
    else return clickTransition + ', transform 200ms ease-out';
  }};
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.32) !important;
  }
`
type CustomColorProps = {
  blue?: boolean;
}
const CustomListItemIcon = styled.div<CustomColorProps>`
  display: inline-flex;
  min-width: 56px;
  flex-shrink: 0;
  color: ${props => props.blue ? '#1e88e5' : 'rgba(0, 0, 0, 0.54)'};
`
type CustomListItemTextProps = CustomColorProps & {
  selected?: boolean;
}
const CustomListItemText = styled.div<CustomListItemTextProps>`
  font-size: 1rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  color: ${props => props.blue ? '#1e88e5' : undefined};
  font-weight: ${props => props.selected ? 'bold' : undefined};
`

type FolderValueType = FolderDb & { order: number }

type PlaceTabsProps = {
  simpleListProps: SimpleListProps;
}
const PlaceTabs: React.FC<PlaceTabsProps> = ({simpleListProps}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      {/* <TabsAppBar position="static" elevation={0}>
        <Tabs value={value} onChange={handleChange} variant="fullWidth">
          <Tab label="所有" {...a11yProps(0)} />
          <Tab label="参加中" {...a11yProps(1)} />
        </Tabs>
      </TabsAppBar>
      <TabPanel value={value} index={0}> */}
        <SimpleList {...simpleListProps} status="own" />
      {/* </TabPanel>
      <TabPanel value={value} index={1}>
        <SimpleList {...simpleListProps} status="join" />
      </TabPanel> */}
    </div>
  );
}

type SimpleListProps = {
  userId: string | undefined;
  status: 'own' | 'join';
  ids: string[];
  values: FolderValueType[];
  setValues: (list: FolderValueType[]) => void;
  draggingId?: string;
  setDraggingId: (id?: string) => void;
  changeOrder: () => void;
}
const SimpleList: React.FC<SimpleListProps> = (props) => {
  const {userId, status, ids, values, setValues, draggingId, setDraggingId, changeOrder} = props;
  const dispatch = useDispatch();
  const currentFolderId = useCurrentFolderId();
  const [userConditionId] = useUserCondition(userId);
  const itemHeight = 48;

  type DialogActionState = {show: boolean}
  const [addFolderAction, setAddFolderAction] = useState<DialogActionState>({show: false});
  const [leaveFolderAction, setLeaveFolderAction] = useState<DialogActionState>({show: false});

  const handleListItemClick = (id: string) => {
    dispatch(setCurrentFolder(id));
    if (userConditionId) dispatch(updateUserCondition({ id: userConditionId, where: 'folder', when: getTimestamp(), folderId: id }));
  }

  return (
    <>
      <div style={{width: '100%', paddingTop: 8, position: 'relative', zIndex: 0}}>
        { ids.map((id, ix) => {
          const folder = values[ix];
          if (!folder) return undefined;
          return (
            <DraggableSort
              draggableProps={{
                position: { x: 0, y: folder.order * itemHeight },
                onStart: () => handleListItemClick(id),
                onStop: () => changeOrder(),
                bounds: { left: 0, top: 0, right: 0, bottom: (values.length - 1) * itemHeight }
              }}
              targetClass="folder-list-item"
              key={id}
              id={id} ids={ids} values={values}
              setValues={setValues}
              setDraggingId={setDraggingId}
            >
              <CustomListItem selected={id === currentFolderId}
                dragging={id === draggingId}
                id={id} className="folder-list-item"
                onClick={() => handleListItemClick(id)}
              >
                <CustomListItemIcon>
                  { id === currentFolderId ? <FolderOpenIcon /> : <FolderIcon /> }
                </CustomListItemIcon>
                <CustomListItemText selected={id === currentFolderId}>{ folder.name }</CustomListItemText>
              </CustomListItem>
            </DraggableSort>
          );
        }) }
        <Draggable disabled position={{x: 0, y: ids.length * itemHeight}}>
          { status === 'own' ? (
            <CustomListItem onClick={() => setAddFolderAction({show: true})}>
              <CustomListItemIcon blue><AddIcon /></CustomListItemIcon>
              <CustomListItemText blue>フォルダを追加する</CustomListItemText>
            </CustomListItem>
          ) : (
            <CustomListItem onClick={() => setLeaveFolderAction({show: true})}>
              <CustomListItemIcon blue><RemoveIcon /></CustomListItemIcon>
              <CustomListItemText blue>このフォルダから抜ける</CustomListItemText>
            </CustomListItem>
          ) }
        </Draggable>
      </div>
      <AddFolderDialog open={addFolderAction.show} onClose={() => setAddFolderAction({show: false})} />
      <LeaveFolderDialog open={leaveFolderAction.show} onClose={() => setLeaveFolderAction({show: false})} />
    </>
  );
}

type FolderListProps = {
  folderIds: string[];
  folders: FolderDb[];
}
const FolderList: React.FC<FolderListProps> = ({folderIds, folders}) => {
  const dispatch = useDispatch();
  const relationUserFolders = useSelector((state: RootState) => state.relationUserFolderDb).relationUserFolders;
  const currentUserId = useCurrentUserId();
  const [folderList, setFolderList] = useState<FolderValueType[]>([]);
  const [draggingId, setDraggingId] = useState<string>();
  const windowSize = useWindowSize();

  useEffect(() => {
    const newFolderList: FolderValueType[] = [];
    folderIds.forEach((id, ix) => {
      const folder = folders[ix];
      const [relationId, relation] = getRuf(id);
      if (!relationId || !relation) return;
      newFolderList.push({ ...folder, order: relation.order });
    })
    setFolderList(newFolderList);
  }, [folderIds, folders])

  const getRuf = (folderId: string): [string, RelationUserFolderDb] => {
    const id = Object.keys(relationUserFolders).filter(id => {
      const target = relationUserFolders[id];
      return target.folderId === folderId && target.userId === currentUserId;
    })[0];
    const value = relationUserFolders[id];
    return [id, value];
  }
  const changeOrder = () => {
    const ids = folderIds;
    const list = folderList;

    ids.forEach((targetId, targetIx) => {
      const value = list[targetIx];
      const [relationId, relation] = getRuf(targetId);
      if (value.order === relation.order) return;
      dispatch(updateRelationUserFolder({ id: relationId, order: value.order }));
    })
  }

  return (
    <FolderListPaper square elevation={1} style={{ height: windowSize.innerHeight - 64, overflow: 'auto' }}>
      <HedderPaper square elevation={0}>
        <Typography variant="body1" style={{ marginLeft: '8px' }}>フォルダ一覧</Typography>
      </HedderPaper>
      <PlaceTabs simpleListProps={{
        userId: currentUserId,
        status: "own",
        ids: folderIds,
        values: folderList,
        setValues: setFolderList,
        draggingId,
        setDraggingId,
        changeOrder
      }} />
    </FolderListPaper>
  );
}

export default FolderList;
